// extracted by mini-css-extract-plugin
export var container = "Squares-module--container--3r4QK";